export const clipping = (string) => {
    if (string?.length > 20) {
      const new_string = string.substring(0, 20) + ".....";
      return new_string;
    }
    return string;
  };